<script>
	let rows = [
		{
			goal: 'Noise Reduction',
			glazingTypes: 'Acoustic lami ',
			indowPro: 'Up to 22+ dBA improvement (STC to 50+)',
		},
		{
			goal: 'Thermal Insulation',
			glazingTypes: 'R-18 Vacuum Insulated Glass',
			indowPro: 'R-8+ (0.125 U-value) total window system performance',
		},
		{
			goal: 'DIY Installation',
			glazingTypes: '6mm Optical Grade Acrylic',
			indowPro: [
				'10 to 13 dBA improvement (STC to 45+)',
				'R-2.4 thermal performance',
			],
		},
	];
</script>

<!-- Mobile: stacked cards -->
<div
	class="
   mb-8 space-y-4
   sm:hidden
 "
>
	{#each rows as r, r1 (r1)}
		<section class="rounded-md border border-gray-200">
			<header class="border-b px-4 py-2 font-semibold">{r.goal}</header>
			<dl class="divide-y">
				<div class="grid grid-cols-12 gap-2 px-4 py-3">
					<dt class="col-span-5 text-gray-500">Glazing Types</dt>
					<dd class="col-span-7">{r.glazingTypes}</dd>
				</div>

				<div class="grid grid-cols-12 gap-2 px-4 py-3">
					<dt class="col-span-5 text-gray-500">IndowPRO</dt>
					<dd class="col-span-7">
						{#if Array.isArray(r.indowPro)}
							<ul class="list-disc space-y-1 pl-5">
								{#each r.indowPro as item, i (i)}
									<li>{item}</li>
								{/each}
							</ul>
						{:else}
							{r.indowPro}
						{/if}
					</dd>
				</div>
			</dl>
		</section>
	{/each}
</div>

<!-- Desktop: table -->
<div
	class="
   mb-8 hidden
   sm:block
 "
>
	<table class="w-full border border-gray-200 text-left">
		<thead class="bg-gray-50">
			<tr>
				<th class="border-b px-4 py-3">Goal</th>
				<th class="border-b px-4 py-3">Glazing Types</th>
				<th class="border-b px-4 py-3">IndowPRO</th>
			</tr>
		</thead>
		<tbody class="[&>tr>td]:px-4 [&>tr>td]:py-3">
			{#each rows as r, r1 (r1)}
				<tr
					class="
       border-b align-top
       last:border-0
     "
				>
					<td class="font-semibold">{r.goal}</td>
					<td>{r.glazingTypes}</td>
					<td>
						{#if Array.isArray(r.indowPro)}
							<ul class="list-disc space-y-1 pl-5">
								{#each r.indowPro as item, i (i)}
									<li>{item}</li>
								{/each}
							</ul>
						{:else}
							{r.indowPro}
						{/if}
					</td>
				</tr>
			{/each}
		</tbody>
	</table>
</div>
